    import { toast } from "react-hot-toast";
    import { apiConnector } from "../apiConnector";
    import { imageEndpoints } from "../apis"; 

    const {
      CREATE_IMAGE_API,
      GET_ALL_IMAGES_API,
      GET_IMAGE_BY_ID_API,
      DELETE_IMAGE_API,
      UPDATE_IMAGE_API,
      GET_IMAGES_BY_CATEGORY_API,
    } = imageEndpoints;

    export function createImage(formData) {
      return async () => {
          const toastId = toast.loading("Uploading Image...");
  
          try {
              const response = await apiConnector("POST", CREATE_IMAGE_API, formData);
              console.log("CREATE IMAGE API RESPONSE:", response);
  
              // if (!response.data.success) {
              //     throw new Error(response.data.message);
              // }
  
              // toast.success("Image Uploaded Successfully");
          } catch (error) {
              // console.log("CREATE IMAGE API ERROR:", error);
              toast.error("Image Upload Failed");
          }
  
          toast.dismiss(toastId);
      };
  }
  


    // Function to get all images
    export function getAllImages() {
      return async () => {
      
        try {
          const response = await apiConnector("GET", GET_ALL_IMAGES_API);

          console.log("GET ALL IMAGES API RESPONSE...........jhdsdjhsdhb.", response);

          if (!response.data.success) {
            throw new Error(response.data.message);
          }


        } catch (error) {
          console.log("GET ALL IMAGES API ERROR............", error);
          toast.error("Failed to fetch images");
        }
      
      };
    }
    // Function to get images by category
    export function getImagesByCategory(categoryId) {
      return async () => {
        try {
          const response = await apiConnector("GET", `${GET_IMAGES_BY_CATEGORY_API}/${categoryId}`);
          console.log("GET IMAGES BY CATEGORY API RESPONSE:", response);
    
          if (!response.data.success) {
            throw new Error(response.data.message);
          }
    
          return response.data; // Return images data by category
        } catch (error) {
          console.log("GET IMAGES BY CATEGORY API ERROR:", error);
          toast.error("Failed to fetch images by category");
          return null; // Return null or handle as appropriate
        }
      };
    }
    

    // Function to get image by ID
    export function getImageById(imageId) {
      return async () => {

        try {
          const response = await apiConnector("GET", `${GET_IMAGE_BY_ID_API}/${imageId}`);

          console.log("GET IMAGE BY ID API RESPONSE............", response);

          if (!response.data.success) {
            throw new Error(response.data.message);
          }


        } catch (error) {
          console.log("GET IMAGE BY ID API ERROR............", error);
          toast.error("Failed to fetch image details");
        }

      };
    }

    // Function to delete an image
    export function deleteImage(imageId) {
      return async () => {
        const toastId = toast.loading("Deleting Image...");

        try {
          const response = await apiConnector("DELETE", `${DELETE_IMAGE_API}/${imageId}`);

          console.log("DELETE IMAGE API RESPONSE............", response);

          if (!response.data.success) {
            throw new Error(response.data.message);
          }

          toast.success("Image Deleted Successfully");
       
        } catch (error) {
          console.log("DELETE IMAGE API ERROR............", error);
          
        }
      
        toast.dismiss(toastId);
      };
    }

    // Function to update an image
    export function updateImage(imageId, updatedData, navigate) {
      return async () => {
        const toastId = toast.loading("Updating Image...");
      
        try {
          const response = await apiConnector("PUT", `${UPDATE_IMAGE_API}/${imageId}`, updatedData);

          console.log("UPDATE IMAGE API RESPONSE............", response);

          if (!response.data.success) {
            throw new Error(response.data.message);
          }

          toast.success("Image Updated Successfully");
          navigate("/images"); // Adjust the navigation as needed
        } catch (error) {
          console.log("UPDATE IMAGE API ERROR............", error);
          toast.error("Image Update Failed");
        }
      
        toast.dismiss(toastId);
      };
    }
